export enum FilterSelectionMode {
  SINGLE = 'single', // Radio button behavior - only one can be active in the group
  MULTI = 'multi', // Checkbox behavior - multiple can be active in the group
  TOGGLE = 'toggle', // Simple on/off toggle - independent of other filters
}

export interface BaseMemoryFilter {
  displayName: string
  isActive: boolean
  priority: number
  group?: string
  selectionMode?: FilterSelectionMode // Defines how this filter group behaves
}

// Islands Filter Groups
export enum IslandFilterGroup {
  Incentivized = 'Incentivized',
  Volatile = 'Volatile',
  IslandType = 'Island Type',
  Range = 'Range',
  LowTvl = 'Low TVL',
  Manager = 'Manager',
  Baults = 'Baults',
  Managed = 'Managed',
}

// Farms Filter Groups
export enum FarmFilterGroup {
  StakingTokenType = 'StakingTokenType',
  Active = 'Active',
  LowTvl = 'Low TVL',
}

// Configuration for each filter group - defines selection behavior
export const filterGroupConfig: Record<string, FilterSelectionMode> = {
  // Islands
  [IslandFilterGroup.Incentivized]: FilterSelectionMode.TOGGLE,
  [IslandFilterGroup.Volatile]: FilterSelectionMode.SINGLE, // Volatile/Stable are mutually exclusive
  [IslandFilterGroup.IslandType]: FilterSelectionMode.SINGLE, // Only one island type at a time
  [IslandFilterGroup.Range]: FilterSelectionMode.TOGGLE,
  [IslandFilterGroup.LowTvl]: FilterSelectionMode.TOGGLE,
  [IslandFilterGroup.Manager]: FilterSelectionMode.TOGGLE,
  [IslandFilterGroup.Baults]: FilterSelectionMode.TOGGLE,
  [IslandFilterGroup.Managed]: FilterSelectionMode.SINGLE,

  // Farms
  [FarmFilterGroup.StakingTokenType]: FilterSelectionMode.MULTI, // Can select multiple token types
  [FarmFilterGroup.Active]: FilterSelectionMode.TOGGLE,
}

// Helper to get selection mode for a filter
export const getFilterSelectionMode = (filter: BaseMemoryFilter): FilterSelectionMode => {
  // 1. Check if filter has explicit selectionMode
  if (filter.selectionMode) return filter.selectionMode

  // 2. Check if filter's group has a configured selection mode
  if (filter.group) return filterGroupConfig[filter.group] || FilterSelectionMode.TOGGLE

  // 3. Default to TOGGLE
  return FilterSelectionMode.TOGGLE
}
